// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_fragment_contacts_edges_node_clientAccessStatus(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
              "ClientContactInvited",
              "ClientContactRegistered"
            ]);
}

var fragmentConverter = {"__root":{"contacts_edges_node_clientAccessStatus":{"u":"fragment_contacts_edges_node_clientAccessStatus"}}};

var fragmentConverterMap = {
  fragment_contacts_edges_node_clientAccessStatus: unwrap_fragment_contacts_edges_node_clientAccessStatus
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

function buyerNeedMatchingType_decode($$enum) {
  if ($$enum === "BROADCAST" || $$enum === "QUIET") {
    return $$enum;
  }
  
}

function buyerNeedMatchingType_fromString(str) {
  return buyerNeedMatchingType_decode(str);
}

var Utils = {
  buyerNeedMatchingType_decode: buyerNeedMatchingType_decode,
  buyerNeedMatchingType_fromString: buyerNeedMatchingType_fromString
};

var node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MyClientsWidgetBuyer_name_buyer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ClientContactsConnection",
      "kind": "LinkedField",
      "name": "contacts",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "alias": null,
            "args": null,
            "concreteType": "ClientContactsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "alias": null,
                  "args": null,
                  "concreteType": "ClientContactV5",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "clientAccessStatus",
                        "plural": false,
                        "selections": [
                          (v0/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v1/*: any*/),
                            "type": "ClientContactInvited",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v1/*: any*/),
                            "type": "ClientContactRegistered",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      "action": "NONE"
                    }
                  ],
                  "storageKey": null
                },
                "action": "NONE"
              }
            ],
            "storageKey": null
          },
          "action": "NONE"
        }
      ],
      "storageKey": null
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "concreteType": "BuyerNeedV5",
        "kind": "LinkedField",
        "name": "buyerNeed",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "matchingType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "autoNotify",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      "action": "THROW"
    }
  ],
  "type": "Buyer",
  "abstractKey": null
};
})());

var wrap_fragment_contacts_edges_node_clientAccessStatus = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_contacts_edges_node_clientAccessStatus = unwrap_fragment_contacts_edges_node_clientAccessStatus;
exports.wrap_fragment_contacts_edges_node_clientAccessStatus = wrap_fragment_contacts_edges_node_clientAccessStatus;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
